module.exports = __webpack_public_path__ + "img/113.de470941.png";